import { SvgIcon } from "@mui/material";
import { bbox, toMercator } from "@turf/turf";
import type { Feature } from "geojson";
import { dryMatterToColor } from "common/utils/grazing-logic";
import geojson2svg from "geojson2svg";

interface FieldIconProps {
  geom?: Feature;
  dryMatterNow: number;
  /** Rendered size in px (defaults to the MUI SvgIcon 24px). */
  size?: number;
}

export default function FieldIcon({
  geom,
  dryMatterNow,
  size,
}: FieldIconProps) {
  const bboxEPSG3857 = bbox(toMercator(geom as Feature));
  const converter = geojson2svg({
    viewportSize: { width: 24, height: 24 },
    mapExtent: {
      left: bboxEPSG3857[0],
      bottom: bboxEPSG3857[1],
      right: bboxEPSG3857[2],
      top: bboxEPSG3857[3],
    },
    output: "path",
  });

  const fieldColor = dryMatterToColor(dryMatterNow, "#b9b9b9");
  const pathData = converter.convert(toMercator(geom as Feature));

  return (
    <SvgIcon
      htmlColor={fieldColor}
      sx={{
        ...(size ? { fontSize: size } : {}),
        color: fieldColor,
        // Ensure the color is applied to the SVG element
        "& svg": {
          color: fieldColor,
        },
        // Force the fill on the path element with high specificity
        "& path": {
          fill: `${fieldColor} !important`,
          stroke: "none !important",
        },
      }}
    >
      <path
        d={pathData}
        fill={fieldColor}
        stroke="none"
        style={{ fill: fieldColor, stroke: "none" }}
      />
    </SvgIcon>
  );
}
